import _assertThisInitialized from "/data/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/data/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/data/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/data/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/data/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _classCallCheck from "/data/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { defineHidden, is, createInterpolator, each, getFluidConfig, isAnimatedString, useForceUpdate } from '@react-spring/shared';
import _extends from '@babel/runtime/helpers/esm/extends';
import { frameLoop } from '@react-spring/shared/globals';
import { forwardRef, useRef, createElement } from 'react';
import { useLayoutEffect } from 'react-layout-effect';
var $node = Symbol.for('Animated:node');

var isAnimated = function isAnimated(value) {
  return !!value && value[$node] === value;
};
/** Get the owner's `Animated` node. */


var getAnimated = function getAnimated(owner) {
  return owner && owner[$node];
};
/** Set the owner's `Animated` node. */


var setAnimated = function setAnimated(owner, node) {
  return defineHidden(owner, $node, node);
};
/** Get every `AnimatedValue` in the owner's `Animated` node. */


var getPayload = function getPayload(owner) {
  return owner && owner[$node] && owner[$node].getPayload();
};

var Animated = /*#__PURE__*/function () {
  /** The cache of animated values */
  function Animated() {
    _classCallCheck(this, Animated);

    this.payload = void 0; // This makes "isAnimated" return true.

    setAnimated(this, this);
  }
  /** Get the current value. Pass `true` for only animated values. */

  /** Get every `AnimatedValue` used by this node. */


  _createClass(Animated, [{
    key: "getPayload",
    value: function getPayload() {
      return this.payload || [];
    }
  }]);

  return Animated;
}();
/** An animated number or a native attribute value */


var AnimatedValue = /*#__PURE__*/function (_Animated) {
  _inherits(AnimatedValue, _Animated);

  var _super = _createSuper(AnimatedValue);

  function AnimatedValue(_value) {
    var _this;

    _classCallCheck(this, AnimatedValue);

    _this = _super.call(this);
    _this._value = _value;
    _this.done = true;
    _this.elapsedTime = void 0;
    _this.lastPosition = void 0;
    _this.lastVelocity = void 0;
    _this.v0 = void 0;

    if (is.num(_this._value)) {
      _this.lastPosition = _this._value;
    }

    return _this;
  }

  _createClass(AnimatedValue, [{
    key: "getPayload",
    value: function getPayload() {
      return [this];
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this._value;
    }
    /**
     * Set the current value and optionally round it.
     *
     * The `step` argument does nothing whenever it equals `undefined` or `0`.
     * It works with fractions and whole numbers. The best use case is (probably)
     * rounding to the pixel grid with a step of:
     *
     *      1 / window.devicePixelRatio
     */

  }, {
    key: "setValue",
    value: function setValue(value, step) {
      if (is.num(value)) {
        this.lastPosition = value;

        if (step) {
          value = Math.round(value / step) * step;

          if (this.done) {
            this.lastPosition = value;
          }
        }
      }

      if (this._value === value) {
        return false;
      }

      this._value = value;
      return true;
    }
  }, {
    key: "reset",
    value: function reset() {
      var done = this.done;
      this.done = false;

      if (is.num(this._value)) {
        this.elapsedTime = 0;
        this.lastPosition = this._value;
        if (done) this.lastVelocity = null;
        this.v0 = null;
      }
    }
  }], [{
    key: "create",
    value: function create(from, _to) {
      return new AnimatedValue(from);
    }
  }]);

  return AnimatedValue;
}(Animated);

var AnimatedString = /*#__PURE__*/function (_AnimatedValue) {
  _inherits(AnimatedString, _AnimatedValue);

  var _super2 = _createSuper(AnimatedString);

  function AnimatedString(from, to) {
    var _this2;

    _classCallCheck(this, AnimatedString);

    _this2 = _super2.call(this, 0);
    _this2._value = void 0;
    _this2._string = null;
    _this2._toString = void 0;
    _this2._toString = createInterpolator({
      output: [from, to]
    });
    return _this2;
  }

  _createClass(AnimatedString, [{
    key: "getValue",
    value: function getValue() {
      var value = this._string;
      return value == null ? this._string = this._toString(this._value) : value;
    }
  }, {
    key: "setValue",
    value: function setValue(value) {
      if (!is.num(value)) {
        this._string = value;
        this._value = 1;
      } else if (_get(_getPrototypeOf(AnimatedString.prototype), "setValue", this).call(this, value)) {
        this._string = null;
      } else {
        return false;
      }

      return true;
    }
  }, {
    key: "reset",
    value: function reset(goal) {
      if (goal) {
        this._toString = createInterpolator({
          output: [this.getValue(), goal]
        });
      }

      this._value = 0;

      _get(_getPrototypeOf(AnimatedString.prototype), "reset", this).call(this);
    }
  }], [{
    key: "create",
    value: function create(from) {
      var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : from;

      if (is.str(from) && is.str(to)) {
        return new AnimatedString(from, to);
      }

      throw TypeError('Expected "from" and "to" to be strings');
    }
  }]);

  return AnimatedString;
}(AnimatedValue);

var TreeContext = {
  current: null
};
/** An object containing `Animated` nodes */

var AnimatedObject = /*#__PURE__*/function (_Animated2) {
  _inherits(AnimatedObject, _Animated2);

  var _super3 = _createSuper(AnimatedObject);

  function AnimatedObject() {
    var _this3;

    var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    _classCallCheck(this, AnimatedObject);

    _this3 = _super3.call(this);
    _this3.source = void 0;

    _this3.setValue(source);

    return _this3;
  }

  _createClass(AnimatedObject, [{
    key: "getValue",
    value: function getValue(animated) {
      if (!this.source) return null;
      var values = {};
      each(this.source, function (source, key) {
        if (isAnimated(source)) {
          values[key] = source.getValue(animated);
        } else {
          var config = getFluidConfig(source);

          if (config) {
            values[key] = config.get();
          } else if (!animated) {
            values[key] = source;
          }
        }
      });
      return values;
    }
    /** Replace the raw object data */

  }, {
    key: "setValue",
    value: function setValue(source) {
      this.source = source;
      this.payload = this._makePayload(source);
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.payload) {
        each(this.payload, function (node) {
          return node.reset();
        });
      }
    }
    /** Create a payload set. */

  }, {
    key: "_makePayload",
    value: function _makePayload(source) {
      if (source) {
        var payload = new Set();
        each(source, this._addToPayload, payload);
        return Array.from(payload);
      }
    }
    /** Add to a payload set. */

  }, {
    key: "_addToPayload",
    value: function _addToPayload(source) {
      var _this4 = this;

      var config = getFluidConfig(source);

      if (config && TreeContext.current) {
        TreeContext.current.dependencies.add(source);
      }

      var payload = getPayload(source);

      if (payload) {
        each(payload, function (node) {
          return _this4.add(node);
        });
      }
    }
  }]);

  return AnimatedObject;
}(Animated);
/** An array of animated nodes */


var AnimatedArray = /*#__PURE__*/function (_AnimatedObject) {
  _inherits(AnimatedArray, _AnimatedObject);

  var _super4 = _createSuper(AnimatedArray);

  function AnimatedArray(from, to) {
    var _thisSuper, _this5;

    _classCallCheck(this, AnimatedArray);

    _this5 = _super4.call(this, null);
    _this5.source = void 0;

    _get((_thisSuper = _assertThisInitialized(_this5), _getPrototypeOf(AnimatedArray.prototype)), "setValue", _thisSuper).call(_thisSuper, _this5._makeAnimated(from, to));

    return _this5;
  }

  _createClass(AnimatedArray, [{
    key: "getValue",
    value: function getValue() {
      return this.source.map(function (node) {
        return node.getValue();
      });
    }
  }, {
    key: "setValue",
    value: function setValue(newValue) {
      var payload = this.getPayload(); // Reuse the payload when lengths are equal.

      if (newValue && newValue.length == payload.length) {
        each(payload, function (node, i) {
          return node.setValue(newValue[i]);
        });
      } else {
        // Remake the payload when length changes.
        this.source = this._makeAnimated(newValue);
        this.payload = this._makePayload(this.source);
      }
    }
    /** Convert the `from` and `to` values to an array of `Animated` nodes */

  }, {
    key: "_makeAnimated",
    value: function _makeAnimated(from) {
      var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : from;
      return from ? from.map(function (from, i) {
        return (isAnimatedString(from) ? AnimatedString : AnimatedValue).create(from, to[i]);
      }) : [];
    }
  }], [{
    key: "create",
    value: function create(from, to) {
      return new AnimatedArray(from, to);
    }
  }]);

  return AnimatedArray;
}(AnimatedObject);

var AnimatedProps = /*#__PURE__*/function (_AnimatedObject2) {
  _inherits(AnimatedProps, _AnimatedObject2);

  var _super5 = _createSuper(AnimatedProps);

  /** Equals true when an update is scheduled for "end of frame" */
  function AnimatedProps(update) {
    var _this6;

    _classCallCheck(this, AnimatedProps);

    _this6 = _super5.call(this, null);
    _this6.update = update;
    _this6.dirty = false;
    return _this6;
  }

  _createClass(AnimatedProps, [{
    key: "setValue",
    value: function setValue(props, context) {
      if (!props) return; // The constructor passes null.

      if (context) {
        TreeContext.current = context;

        if (props.style) {
          var createAnimatedStyle = context.host.createAnimatedStyle;
          props = _extends(_extends({}, props), {}, {
            style: createAnimatedStyle(props.style)
          });
        }
      }

      _get(_getPrototypeOf(AnimatedProps.prototype), "setValue", this).call(this, props);

      TreeContext.current = null;
    }
    /** @internal */

  }, {
    key: "onParentChange",
    value: function onParentChange(_ref) {
      var _this7 = this;

      var type = _ref.type;

      if (!this.dirty && type === 'change') {
        this.dirty = true;
        frameLoop.onFrame(function () {
          _this7.dirty = false;

          _this7.update();
        });
      }
    }
  }]);

  return AnimatedProps;
}(AnimatedObject);

var withAnimated = function withAnimated(Component, host) {
  return forwardRef(function (rawProps, ref) {
    var instanceRef = useRef(null);
    var hasInstance = // Function components must use "forwardRef" to avoid being
    // re-rendered on every animation frame.
    !is.fun(Component) || Component.prototype && Component.prototype.isReactComponent;
    var forceUpdate = useForceUpdate();
    var props = new AnimatedProps(function () {
      var instance = instanceRef.current;

      if (hasInstance && !instance) {
        return; // The wrapped component forgot to forward its ref.
      }

      var didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false; // Re-render the component when native updates fail.

      if (didUpdate === false) {
        forceUpdate();
      }
    });
    var dependencies = new Set();
    props.setValue(rawProps, {
      dependencies: dependencies,
      host: host
    });
    useLayoutEffect(function () {
      each(dependencies, function (dep) {
        return dep.addChild(props);
      });
      return function () {
        return each(dependencies, function (dep) {
          return dep.removeChild(props);
        });
      };
    });
    return /*#__PURE__*/createElement(Component, _extends({}, host.getComponentProps(props.getValue()), {
      ref: hasInstance && function (value) {
        instanceRef.current = updateRef(ref, value);
      }
    }));
  });
};

function updateRef(ref, value) {
  if (ref) {
    if (is.fun(ref)) ref(value);else ref.current = value;
  }

  return value;
} // For storing the animated version on the original component


var cacheKey = Symbol.for('AnimatedComponent');

var createHost = function createHost(components) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$applyAnimatedVa = _ref2.applyAnimatedValues,
      applyAnimatedValues = _ref2$applyAnimatedVa === void 0 ? function () {
    return false;
  } : _ref2$applyAnimatedVa,
      _ref2$createAnimatedS = _ref2.createAnimatedStyle,
      createAnimatedStyle = _ref2$createAnimatedS === void 0 ? function (style) {
    return new AnimatedObject(style);
  } : _ref2$createAnimatedS,
      _ref2$getComponentPro = _ref2.getComponentProps,
      getComponentProps = _ref2$getComponentPro === void 0 ? function (props) {
    return props;
  } : _ref2$getComponentPro;

  var hostConfig = {
    applyAnimatedValues: applyAnimatedValues,
    createAnimatedStyle: createAnimatedStyle,
    getComponentProps: getComponentProps
  };

  var animated = function animated(Component) {
    var displayName = getDisplayName(Component) || 'Anonymous';

    if (is.str(Component)) {
      Component = withAnimated(Component, hostConfig);
    } else {
      Component = Component[cacheKey] || (Component[cacheKey] = withAnimated(Component, hostConfig));
    }

    Component.displayName = "Animated(" + displayName + ")";
    return Component;
  };

  each(components, function (Component, key) {
    if (!is.str(key)) {
      key = getDisplayName(Component);
    }

    animated[key] = animated(Component);
  });
  return {
    animated: animated
  };
};

var getDisplayName = function getDisplayName(arg) {
  return is.str(arg) ? arg : arg && is.str(arg.displayName) ? arg.displayName : is.fun(arg) && arg.name || null;
};

export { Animated, AnimatedArray, AnimatedObject, AnimatedProps, AnimatedString, AnimatedValue, createHost, getAnimated, getPayload, isAnimated, setAnimated };